var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "caixa-dropdown",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('header', {
    staticClass: "caixa-dropdown__header"
  }, [_c('div', {
    staticClass: "caixa-dropdown__title"
  }, [_c('i', {
    staticClass: "fas fa-cash-register"
  }), _c('span', [_vm._v("Caixa")]), _c('span', {
    staticClass: "caixa-dropdown__badge",
    class: _vm.caixaAberto ? 'caixa-dropdown__badge--aberto' : 'caixa-dropdown__badge--fechado'
  }, [_vm._v(" " + _vm._s(_vm.caixaAberto ? 'Aberto' : 'Fechado') + " ")])]), _c('button', {
    staticClass: "caixa-dropdown__close",
    attrs: {
      "title": "Fechar"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('fechar');
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-times"
  })])]), _vm.caixaAberto ? _c('section', {
    staticClass: "caixa-dropdown__body"
  }, [_c('div', {
    staticClass: "caixa-dropdown__row"
  }, [_c('span', {
    staticClass: "caixa-dropdown__label"
  }, [_vm._v("Operador")]), _c('span', {
    staticClass: "caixa-dropdown__value"
  }, [_vm._v(_vm._s(_vm.operadorNome || '—'))])]), _c('div', {
    staticClass: "caixa-dropdown__row"
  }, [_c('span', {
    staticClass: "caixa-dropdown__label"
  }, [_vm._v("Terminal")]), _c('span', {
    staticClass: "caixa-dropdown__value"
  }, [_vm._v(_vm._s(_vm.terminalNome || '—'))])]), _c('div', {
    staticClass: "caixa-dropdown__row"
  }, [_c('span', {
    staticClass: "caixa-dropdown__label"
  }, [_vm._v("Aberto em")]), _c('span', {
    staticClass: "caixa-dropdown__value"
  }, [_vm._v(_vm._s(_vm.formatarData(_vm.caixaAberto.data_abertura)))])]), !_vm.fechamentoAsCegas ? _c('div', {
    staticClass: "caixa-dropdown__row"
  }, [_c('span', {
    staticClass: "caixa-dropdown__label"
  }, [_vm._v("Valor de abertura")]), _c('span', {
    staticClass: "caixa-dropdown__value"
  }, [_vm._v(_vm._s(_vm.formatBRL(_vm.caixaAberto.valor_abertura)))])]) : _vm._e(), !_vm.fechamentoAsCegas ? _c('div', {
    staticClass: "caixa-dropdown__divider"
  }) : _vm._e(), !_vm.fechamentoAsCegas ? _c('div', {
    staticClass: "caixa-dropdown__row caixa-dropdown__row--strong"
  }, [_c('span', {
    staticClass: "caixa-dropdown__label"
  }, [_vm._v("Total vendido")]), _c('span', {
    staticClass: "caixa-dropdown__value"
  }, [_vm._v(_vm._s(_vm.formatBRL(_vm._get('total_vendas'))))])]) : _vm._e(), !_vm.fechamentoAsCegas ? _c('div', {
    staticClass: "caixa-dropdown__row"
  }, [_c('span', {
    staticClass: "caixa-dropdown__label"
  }, [_vm._v("Total dinheiro")]), _c('span', {
    staticClass: "caixa-dropdown__value"
  }, [_vm._v(_vm._s(_vm.formatBRL(_vm._get('total_dinheiro'))))])]) : _vm._e(), !_vm.fechamentoAsCegas && _vm.formasVendaList.length ? _vm._l(_vm.formasVendaList, function (f) {
    return _c('div', {
      key: f.forma,
      staticClass: "caixa-dropdown__row caixa-dropdown__row--sub"
    }, [_c('span', {
      staticClass: "caixa-dropdown__label"
    }, [_vm._v(_vm._s(f.forma))]), _c('span', {
      staticClass: "caixa-dropdown__value"
    }, [_vm._v(_vm._s(_vm.formatBRL(f.valor)))])]);
  }) : _vm._e(), !_vm.fechamentoAsCegas ? _c('div', {
    staticClass: "caixa-dropdown__divider"
  }) : _vm._e(), !_vm.fechamentoAsCegas ? _c('div', {
    staticClass: "caixa-dropdown__row"
  }, [_c('span', {
    staticClass: "caixa-dropdown__label"
  }, [_vm._v("Suprimentos")]), _c('span', {
    staticClass: "caixa-dropdown__value"
  }, [_vm._v(_vm._s(_vm.formatBRL(_vm._get('suprimentos'))))])]) : _vm._e(), !_vm.fechamentoAsCegas ? _c('div', {
    staticClass: "caixa-dropdown__row"
  }, [_c('span', {
    staticClass: "caixa-dropdown__label"
  }, [_vm._v("Sangrias")]), _c('span', {
    staticClass: "caixa-dropdown__value"
  }, [_vm._v(_vm._s(_vm.formatBRL(_vm._get('sangrias'))))])]) : _vm._e(), !_vm.fechamentoAsCegas ? _c('div', {
    staticClass: "caixa-dropdown__divider"
  }) : _vm._e(), !_vm.fechamentoAsCegas ? _c('div', {
    staticClass: "caixa-dropdown__row caixa-dropdown__row--strong"
  }, [_c('span', {
    staticClass: "caixa-dropdown__label"
  }, [_vm._v("Dinheiro esperado em caixa")]), _c('span', {
    staticClass: "caixa-dropdown__value"
  }, [_vm._v(_vm._s(_vm.formatBRL(_vm._get('valor_esperado'))))])]) : _vm._e(), _vm.fechamentoAsCegas ? _c('p', {
    staticClass: "caixa-dropdown__hint"
  }, [_c('i', {
    staticClass: "fas fa-eye-slash"
  }), _vm._v(" Conferência às cegas ativa. Os valores do caixa ficam ocultos para o operador. ")]) : _vm._e(), _vm.pendentesSync > 0 ? _c('p', {
    staticClass: "caixa-dropdown__alert"
  }, [_c('i', {
    staticClass: "fas fa-cloud-upload-alt"
  }), _vm._v(" Existem movimentações de caixa pendentes de sincronização (" + _vm._s(_vm.pendentesSync) + "). ")]) : _vm._e()], 2) : _c('section', {
    staticClass: "caixa-dropdown__body"
  }, [_vm._m(0), _c('p', {
    staticClass: "caixa-dropdown__hint"
  }, [_vm._v(" Abra um caixa para iniciar as vendas. ")])]), _c('footer', {
    staticClass: "caixa-dropdown__actions"
  }, [_vm.caixaAberto ? [_c('button', {
    staticClass: "caixa-dropdown__action",
    on: {
      "click": function click($event) {
        return _vm.$emit('sangria');
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-arrow-up"
  }), _vm._v(" Sangria ")]), _c('button', {
    staticClass: "caixa-dropdown__action",
    on: {
      "click": function click($event) {
        return _vm.$emit('suprimento');
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-arrow-down"
  }), _vm._v(" Suprimento ")]), _c('button', {
    staticClass: "caixa-dropdown__action",
    on: {
      "click": function click($event) {
        return _vm.$emit('resumo-completo');
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-list-alt"
  }), _vm._v(" Comprovantes / Resumo ")]), _c('button', {
    staticClass: "caixa-dropdown__action",
    attrs: {
      "disabled": _vm.sincronizando || !_vm.online,
      "title": !_vm.online ? 'Sem conexão — não é possível sincronizar agora' : ''
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('sincronizar');
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-sync",
    class: {
      'fa-spin': _vm.sincronizando
    }
  }), _vm._v(" " + _vm._s(_vm.sincronizando ? 'Sincronizando…' : !_vm.online ? 'Sincronizar (offline)' : 'Sincronizar caixa') + " ")]), _c('button', {
    staticClass: "caixa-dropdown__action",
    attrs: {
      "disabled": _vm.sincronizando || !_vm.online,
      "title": !_vm.online ? 'Sem conexão — não é possível recarregar agora' : 'Recarrega todas as combinações/variações do servidor'
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('recarregar-combinacoes');
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-layer-group"
  }), _vm._v(" Recarregar combinações ")]), _c('button', {
    staticClass: "caixa-dropdown__action caixa-dropdown__action--danger",
    on: {
      "click": function click($event) {
        return _vm.$emit('fechar-caixa');
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-lock"
  }), _vm._v(" Fechar caixa ")])] : [_c('button', {
    staticClass: "caixa-dropdown__action caixa-dropdown__action--success",
    on: {
      "click": function click($event) {
        return _vm.$emit('abrir-caixa');
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-lock-open"
  }), _vm._v(" Abrir caixa ")]), _c('button', {
    staticClass: "caixa-dropdown__action",
    on: {
      "click": function click($event) {
        return _vm.$emit('resumo-completo');
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-history"
  }), _vm._v(" Ver caixas anteriores ")])]], 2)]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('p', {
    staticClass: "caixa-dropdown__empty"
  }, [_c('i', {
    staticClass: "fas fa-lock"
  }), _vm._v(" Nenhum caixa aberto neste terminal. ")]);
}];
export { render, staticRenderFns };